import { Component } from '@angular/core';
import { AlertController, NavController, NavParams, ToastController } from 'ionic-angular';
import { FormBuilder } from '@angular/forms';
import { Globals } from "../../../../globals";
import { ConfigurationServices } from "../../services";
import { TranslateService } from '@ngx-translate/core';
import { AnalyticsServices } from '../../../services/analyticsServices';

/**
 * Generated class for the ConfigurationPaymentTakeawayPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-configuration-payment-takeaway',
  templateUrl: 'configuration-payment-takeaway.html',
})
export class ConfigurationPaymentTakeawayPage {

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public fb: FormBuilder,
    public configurationServices: ConfigurationServices,
    public globals: Globals,
    public translate: TranslateService,
    public toastCtrl: ToastController,
    public alertCtrl: AlertController,
    public analyticsServices: AnalyticsServices) {
    //notificacion de interes sobre el pay
    if (!this.globals.restaurant.payment_method_on_delivery || this.globals.restaurant.payment_method_on_delivery == undefined) {
      this.globals.sendIntegrationSlack('PAYMENT METHODS', 'OPEN ON DELIVERY');
    }
  }

  changeTakeaway(active) {
    this.configurationServices.afs.collection('restaurants').doc(this.globals.restaurant_uid).update({
      'payment_method_on_delivery': active
    }).then(() => {
      this.globals.restaurant.payment_method_on_delivery = active;
      //trackingPLGPedidos
      this.analyticsServices.trackingExpPedidos('pay_config', this.globals.tracking_exp['pay_config']);
    });
  }

}


// WEBPACK FOOTER //
// ./src/pages/configuration/configuration-payment-methods/configuration-payment-takeaway/configuration-payment-takeaway.ts